/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Warehouse_Movement_TitleInputs */

const vi_dashboard_warehouse_movement_title = /** @type {(inputs: Dashboard_Warehouse_Movement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập/Xuất kho theo thời gian`)
};

/**

* @param {Dashboard_Warehouse_Movement_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_warehouse_movement_title = /** @type {((inputs?: Dashboard_Warehouse_Movement_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Warehouse_Movement_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_warehouse_movement_title(inputs)
});